import {} from "./enums";
import { FILE_FORMAT_MESSGAES } from "./messages";

export const IMAGE_FORMAT = "image/jpeg,image/png,image/jpg";
export const VIDEO_FORMAT = "video/mp4,video/x-m4v,video/*";
export const AUDIO_FORMAT = "audio/mpeg,audio/mp3";

export const MAX_SIZE_ERROR = (size = MAX_IMAGE_SIZE) =>
  `Image of ${size} not allowed`;

export const DOCUMENT_FORMAT =
  "image/jpeg,image/png,image/jpg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx,.doc";

export const DOCUMENT_FORMAT_ERROR = FILE_FORMAT_MESSGAES.INVALID_DOCUMENT_FORMAT.replace(
  "$format$",
  ".png/.jpg/.jpeg/.pdf/.doc/.docx"
);
export const IMAGE_FORMAT_ERROR = FILE_FORMAT_MESSGAES.INVALID_IMAGE_FORMAT.replace(
  "$format$",
  "jpeg/png"
);
export const VIDEO_FORMAT_ERROR = FILE_FORMAT_MESSGAES.INVALID_VIDEO_FORMAT.replace(
  "$format$",
  "video/mp4"
);

export const CHAT_FILE_ERROR = FILE_FORMAT_MESSGAES.INVALID_CHAT_FILE_FORMAT.replace(
  "$format$",
  "video/mp4,.png/.jpg/.jpeg/.pdf/.doc/.docx,audio/mp3"
);
export const MAX_IMAGE_SIZE = 10;

export const MAX_DOCUMENT_SIZE = 10;

export const MAX_IMAGE_LENGTH = 50;

export const MIN_IMAGE_LENGTH = 5;

export const CHAT_MESSAGES_PAGE_LIMIT = 100;
export const CHAT_INBOX_PAGE_LIMIT = 2;

export const CHAT_MAX_FILE_SIZE = 100; // mb

export const HOME_SECTIONS_IDS = {
  LOCATION: "location-section",
  PARTNER: "partner-section",
};
export const PROFILE_DETAILS_IDS = {
  ABOUT: "about-section",
  AMENITIES: "amenities-section",
  CATEGORY: "category-price-section",
  RATING: "rating-review-section",
};

export const PAGE_KEY = "page";
export const LIMIT_KEY = "limit";
export const PAGE_START = 1;
export const PROPERTY_PAGINATION = 10;
export const MAX_LOCATION_COUNT = 5;

export const PAGE_OPTIONS = {
  page: PAGE_START,
  limit: PROPERTY_PAGINATION,
};
export const PAGE_OPTIONS_100 = {
  page: PAGE_START,
  limit: 100,
};
export const SMALL_PAGE_OPTIONS = {
  page: 1,
  limit: 5,
};

export const RANGE_UPDATE_TIME = 1000; // in ms

export const customHeader = {
  devicedetails: {
    token: "aefdinewfewnfewkfwe",
    deviceId: "nmmzzefewfwf",
    type: 1,
  },
  offset: new Date().getTimezoneOffset(),
};

export const YEAR_START = new Date().getFullYear();
export const YEAR_RANGE = new Date().getFullYear() + 20;

export const MY_FORMATS = {
  parse: {
    dateInput: "MMM DD, yyyy",
  },
  display: {
    dateInput: "MMM DD, yyyy",
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY",
  },
};

export const FAQ_URL = "https://admin.paradisefoodcourt.in/faq/";
export const TERMS_OF_USE = "https://admin.paradisefoodcourt.in/terms/";
export const PRIVACY = "https://admin.paradisefoodcourt.in/privacy/";

export const MODES_OF_PAYMENTS = [
  // {value: 'cash', viewValue: 'Cash' },
  { value: "online", viewValue: "Card, Net Banking, E-Wallets" },
];

export const FEEDBACK_TYPES = [
  "Biryani was not tasty",
  "Food was not fresh",
  "Food was delivered late",
  "Main course/Curry was lacking in flavour",
  "Spice/Masala level could have been better",
  "Rider was not courteous",
  "Rider was not well groomed",
  "Taste of Starters was not as expected",
  "The food was not served hot",
];

export enum WEB_ORDER_STEPS {
  CART="cart",
  ADDRESS="address",
  PAYMENT="payment"
}

export const STAR_RATING_OPTIONS = [1,2,3,4,5]